import React from "react";
import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import AsyncSelect from "react-select/async";
import debounce from "debounce-promise";
import { useConfig } from "@peracto/peracto-config";
import axios from "axios";

const ArticlesForm = ({
    onChange,
    state: { articleCategory, heading = "Articles" },
}) => {
    const config = useConfig();
    const API_URL = config.get("api");

    const fetchArticleCategories = async (input) => {
        const { data } = await axios.get(
            `${API_URL}/article-categories?itemsPerPage=1000&name=${
                input || ""
            }`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            }
        );

        const parsedData = data["hydra:member"];

        const values = parsedData.map((articleCategory) => ({
            label: articleCategory.name,
            value: `${articleCategory.id}`,
        }));

        return values;
    };

    const debouncedFetchArticleCategories = debounce(
        fetchArticleCategories,
        200
    );

    return (
        <>
            <TextInput
                label="Heading"
                onChange={(e) => {
                    onChange({ heading: e.target.value });
                }}
                value={heading}
            />

            <div className="form-group">
                <label>Article Category</label>
                <AsyncSelect
                    className="w-100"
                    loadOptions={(input) =>
                        debouncedFetchArticleCategories(input)
                    }
                    isSearchable={true}
                    defaultOptions={true}
                    onChange={(option) =>
                        onChange({ articleCategory: option.value })
                    }
                    placeholder="Select an article category..."
                    classNamePrefix="peracto-select"
                    noOptionsMessage={({ inputValue }) => {
                        if (inputValue.length > 0) {
                            return `No article categories found for '${inputValue}'.`;
                        } else {
                            return "Enter text to begin searching.";
                        }
                    }}
                />
            </div>
        </>
    );
};

export default ArticlesForm;
